import { createValidator } from "@wisr/common";
import { AustralianState } from "../credit-profile-form.options";

export const validateNumericLicenceNumber =
  (minLength: number, maxLength: number) =>
  (value: string): boolean => {
    const regex = new RegExp(`^\\d{${minLength},${maxLength}}$`);
    return regex.test(value);
  };

export const validateAlphaNumericLicenceNumber =
  (minLength: number, maxLength: number) =>
  (value: string): boolean => {
    const regex = new RegExp(`^[A-Za-z0-9]{${minLength},${maxLength}}$`);
    return regex.test(value);
  };

const createLicenceNumberValidator = (
  validatorFunction: (value: string) => boolean,
  state: string
) => {
  return createValidator(
    validatorFunction,
    `Enter a valid ${state} licence number`
  );
};

export const validateLicenceNumber = (value: string): boolean => {
  return /^[a-zA-Z0-9]*$/.test(value);
};

export const licenceNumberValidator = createValidator(
  validateLicenceNumber,
  "Please enter a valid licence number"
);

export const getLicenceNumberValidator = (state: string) => {
  switch (state) {
    case AustralianState.ACT:
    case AustralianState.NT:
    case AustralianState.VIC:
      return createLicenceNumberValidator(
        validateNumericLicenceNumber(1, 10),
        state
      );
    case AustralianState.QLD:
      return createLicenceNumberValidator(
        validateNumericLicenceNumber(8, 9),
        state
      );
    case AustralianState.NSW:
    case AustralianState.TAS:
      return createLicenceNumberValidator(
        validateAlphaNumericLicenceNumber(6, 8),
        state
      );
    case AustralianState.SA:
      return createLicenceNumberValidator(
        validateAlphaNumericLicenceNumber(6, 6),
        state
      );
    case AustralianState.WA:
      return createLicenceNumberValidator(
        validateNumericLicenceNumber(1, 7),
        state
      );
    default:
      return licenceNumberValidator;
  }
};

const createLicenceCardNumberValidator = (
  validatorFunction: (value: string) => boolean,
  state: string
) => {
  return createValidator(
    validatorFunction,
    `Enter a valid ${state} licence card number`
  );
};

export const getLicenceCardNumberValidator = (state: string) => {
  switch (state) {
    case AustralianState.ACT:
    case AustralianState.QLD:
      return createLicenceCardNumberValidator(
        validateAlphaNumericLicenceNumber(10, 10),
        state
      );
    case AustralianState.NT:
      return createLicenceCardNumberValidator(
        validateNumericLicenceNumber(6, 8),
        state
      );
    case AustralianState.NSW:
      return createLicenceCardNumberValidator(
        validateNumericLicenceNumber(10, 10),
        state
      );
    case AustralianState.SA:
    case AustralianState.TAS:
      return createLicenceCardNumberValidator(
        validateAlphaNumericLicenceNumber(9, 9),
        state
      );
    case AustralianState.VIC:
      return createLicenceCardNumberValidator(
        validateAlphaNumericLicenceNumber(8, 8),
        state
      );
    default:
      return licenceNumberValidator;
  }
};
